/**
 * Today's date in the user's local calendar as `YYYY-MM-DD` (for `<input type="date">`).
 */
export function localCalendarDateOnlyToday(): string {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
